import type { ImageLoaderProps } from 'next/image'

// Hosts fronted by Akamai Image & Video Manager, which resizes + format-negotiates at the
// edge via the `imwidth` param — so Next's on-pod `/_next/image` optimizer can be skipped.
const IVM_HOSTS = new Set([
    'images.traum-ferienwohnungen.de',
    'img2.traum-ferienwohnungen.de',
    'static2.traum-ferienwohnungen.de',
])

// True when `src` is an absolute URL on an IVM host (safe to serve straight from the edge).
export const isAkamaiOptimizable = (src: string): boolean => {
    try {
        return IVM_HOSTS.has(new URL(src).hostname)
    } catch {
        return false
    }
}

// Serves the image from Akamai IVM at the responsive breakpoint width. `imwidth` is set
// (overriding any pre-existing value) so it tracks Next's chosen width, not a fixed source
// size. Quality is governed by the IVM policy, so it is not forwarded.
export default function akamaiImageLoader({ src, width }: ImageLoaderProps): string {
    const url = new URL(src)
    url.searchParams.set('imwidth', String(width))
    return url.toString()
}
